import { render, staticRenderFns } from "./SetPasswordForAdmin.vue?vue&type=template&id=6752f4e9&scoped=true"
import script from "./SetPasswordForAdmin.vue?vue&type=script&lang=ts"
export * from "./SetPasswordForAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6752f4e9",
  null
  
)

export default component.exports